import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DirGeo",
  "use": "DirGeo-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"DirGeo\"><path fill-rule=\"evenodd\" d=\"M24 22c0-4.488 3.512-8 8-8 4.468 0 8 3.512 8 8 0 4.468-3.532 8-8 8-4.488 0-8-3.532-8-8zm-14 .708C10 38.828 32.01 63 32.01 63S54 38.828 54 22.708C54 10.61 44.256 1 32.01 1 19.744 1 10 10.61 10 22.708zm3 .04c0 13.921 19.008 34.797 19.008 34.797S51 36.67 51 22.748C51 12.3 42.585 4 32.008 4 21.415 4 13 12.3 13 22.748z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol